import styled from 'styled-components';

const Footer = styled.footer`
  .footer__stack-horizontal,
  .footer__stack-vertical {
    display: flex;
  }

  .footer__stack-vertical {
    flex-direction: column;
    align-items: center;
  }
`;

export const S = {
  Footer
};
